import AjaxService from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const createRecursionRule = ({ task, milestone, type, trigger, cron, till, bi_weekly }) => {
    return AjaxService({
        method: 'post',
        url: 'rules',
        data: {
            task_id: task,
            milestone_id: milestone,
            type,
            trigger,
            cron,
            till,
            bi_weekly
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const fetchRecursionRule = ruleId => {
    return AjaxService({
        method: 'get',
        url: `rules/${ruleId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const updateRecursionRule = (ruleId, { type, trigger, cron, till, bi_weekly }) => {
    return AjaxService({
        method: 'put',
        url: `rules/${ruleId}`,
        data: {
            type,
            trigger,
            cron,
            till,
            bi_weekly
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeRecursionRule = ruleId => {
    return AjaxService({
        method: 'delete',
        url: `rules/${ruleId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}
